module.exports = __webpack_public_path__ + "static/img/jxkp.68d85c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/car/jxkp.png
// module id = /65I
// module chunks = 37